import {
  Base64URLDecode,
  Base64URLEncode,
  JSONDecode,
  JSONEncode,
  StringToUInt8,
  UInt8ToString,
} from "@pdfking/tfunc"

export default {
  loads: (s: string) => JSONDecode(UInt8ToString(Base64URLDecode(s))),
  dumps: (s: any) => Base64URLEncode(StringToUInt8(JSONEncode(s))),
}
